import { useCallback } from "react";
import jwt_decode from 'jwt-decode';
import { ICity, IPanelUser } from "../interfaces";

export default function useLocalStorage() {

    const getToken = useCallback((): string | undefined => {
        let localStorageData: string | null = localStorage.getItem('@NotaMunicipio:token');
        let parsedLocalStorageData: any = null;

        if (typeof localStorageData == 'string') {
            parsedLocalStorageData = JSON.parse(localStorageData);
            return parsedLocalStorageData.token;
        }
        
        return undefined;
    }, []);

    const getRefreshToken = useCallback((): string | undefined => {
        let localStorageData: string | null = localStorage.getItem('@NotaMunicipio:rftoken');
        let parsedLocalStorageData: any = null;

        if (typeof localStorageData == 'string') {
            parsedLocalStorageData = JSON.parse(localStorageData);
            return parsedLocalStorageData.refresh_token;
        }

        return undefined;
    }, []);

    const getUser = useCallback((): IPanelUser | undefined => {
        let localStorageData: string | null = localStorage.getItem('@NotaMunicipio:user');
        let parsedLocalStorageData: any = null;

        if (typeof localStorageData == 'string') {
            parsedLocalStorageData = JSON.parse(localStorageData);
            return parsedLocalStorageData.user
        }
        
        return undefined;
    }, []);

    const getSelectedCityFromStorage = useCallback((): ICity | undefined => {
        let localStorageData: string | null = localStorage.getItem('@NotaMunicipio:selectedCity');
        let parsedLocalStorageData: any = null;

        if (typeof localStorageData == 'string') {
            parsedLocalStorageData = JSON.parse(localStorageData);
            return parsedLocalStorageData.city;
        }
        
        return undefined;
    }, []);

    const getUserId = useCallback((): string | undefined => {
        let localStorageData: string | null = localStorage.getItem('@NotaMunicipio:rftoken');
        let parsedLocalStorageData: any = null;
        if (typeof localStorageData == 'string') {
            parsedLocalStorageData = JSON.parse(localStorageData);
    
            if (parsedLocalStorageData.refresh_token) {
                let decodedToken: any = jwt_decode(parsedLocalStorageData.refresh_token);
    
                if (decodedToken && decodedToken != null && decodedToken?.sub) {
                    //retorna o id do usuario
                    return decodedToken?.sub
                }
            }

            return undefined;
        } 

        return undefined;
    }, []);

    const removeTokenFromLocalStorage = useCallback((): void => {
        const token: string | null = localStorage.getItem('@NotaMunicipio:token');
        let parsedToken: any = null;
        if (typeof token == 'string') {
            parsedToken = JSON.parse(token);
        }
    
        if (parsedToken) {
            localStorage.removeItem('@NotaMunicipio:token');
        }
    }, []);

    const removeRefreshTokenFromLocalStorage = useCallback((): void => {
        let refreshToken: string | null = localStorage.getItem('@NotaMunicipio:rftoken');
        let parsedRefreshToken: any = null;
        if (typeof refreshToken == 'string') {
            parsedRefreshToken = JSON.parse(refreshToken);
        }
    
        if (parsedRefreshToken) {
            localStorage.removeItem('@NotaMunicipio:rftoken');
        }
    }, []);

    const removeUserFromLocalStorage = useCallback((): void => {
        let user: string | null = localStorage.getItem('@NotaMunicipio:user');
        let parsedUser: any = null;
        if (typeof user == 'string') {
            parsedUser = JSON.parse(user);
        }
    
        if (parsedUser) {
            localStorage.removeItem('@NotaMunicipio:user');
        }
    }, []);

    const removeSelectedCityFromLocalStorage = useCallback((): void => {
        let city: string | null = localStorage.getItem('@NotaMunicipio:selectedCity');
        let parsedCity: any = null;
        if (typeof city == 'string') {
            parsedCity = JSON.parse(city);
        }
    
        if (parsedCity) {
            localStorage.removeItem('@NotaMunicipio:selectedCity');
        }
    }, []);

    return {
        getToken,
        getRefreshToken,
        getUser,
        getUserId,
        getSelectedCityFromStorage,
        removeTokenFromLocalStorage,
        removeRefreshTokenFromLocalStorage,
        removeUserFromLocalStorage,
        removeSelectedCityFromLocalStorage,
    }

}